export class RouterPathConfig {
    public static HOME_PATH = 'home';

    public static REQUEST_PATH = {
        NEW_REQUESTS: 'new-requests',
        RETURNED_REQUESTS: 'returned-requests',
        ASSIGNED_TO_ME_REQUESTS: 'requests-assigned-to-me',
        INPROGRESS_REQUESTS: 'in-progress-requests',
        SECURITY_COORDINATOR_REQUESTS: 'security-coordinator-requests',
        COMPLETED_REQUESTS: 'completed-requests',
        EMPLOYEE_MANAGEMENT_REQUESTS: 'employee-management-requests',
        COMPLETED_HISTORY_REQUESTS: 'completed-history-requests',
        TECHNICAL_OPERATIONS_REQUESTS: 'technical-operations-requests'
    };

    public static USER_PATH = {
        ADMIN: 'admin',
        MANAGER: 'manager',
        EMPLOYEE: 'employee',
        REQUESTER: 'requester',
        ACCOUNT_MANAGER: 'account-manager'
    };

    public static CREATE_REQUEST_PATH = 'create-request';
    public static CREATE_USER_EMPOLYEE_PATH = 'create-user-empolyee';
    public static CREATE_CALL_RECORD_PATH = 'create-record';
    public static VIEW_CALL_RECORD_PATH = 'view-record';

    public static LOGIN_PATH = 'login';

    public static DASHBOARD_PATH = {
        CLIENTS_LIST_PATH: 'clients-list',
        EMPLOYEES_LIST_PATH: 'employees-list',
        OPERATIONS_LIST_PATH: 'operations-list'
    };

    public static DATA_MANAGEMENT_PATH = {
        ADMINS: 'admins',
        EMPLOYEES: 'employees',
        CLIENTS: 'clients',
        SERVICES: 'services',
        SYSTEMS: 'systems',
        OPERATIONEMPLOYEE: 'empolyeeOperation'
    };
    public static FILE_MANAGEMENT_PATH = {
        STORAGE_UNIT: 'storage-unit',
        ACTIVITY: 'activity',
        SHARED_FILES: 'shared-files',
        FAVORITE_LIST: 'favorite-list',
        DELETED_FILES: 'deleted-files'
    };
    public static CALL_CENTER_CLIENT_MANAGEMENT_PATH = {
        CLIENTS: 'client-list',
        REQUESTS: 'request-list',
        INQUIRY_DASHBOARD: 'inquiry-dashboard',
        CALL_RECORD_DASHBOARD: 'call-record-dashboard'
    };
    public static PERIODIC_REVIEW_PATH = {
        REPORTS: 'reports',
        SHARED_REPORTS: 'shared-reports'
    };
    public static DATA_MANAGEMENT = 'data-management';
    public static FILE_MANAGEMENT = 'file-management';
    public static PERIODIC_REVIEW = 'periodic-review';
    public static DELEGATION = 'delegation';
    public static CALL_CENTER_CLIENT_MANAGEMENT = 'call-center-client-management';
    public static CALL_CENTER_CLIENT_MANAGEMENT_REQUEST = 'request-list';

    public static STRATEGY = 'strategy';
    public static EMPOLYEE_MANAGEMENT_STATUS = 'empolyee-managment';
    public static CLIENT_MANAGEMENT_USERS = 'client-management-users';

    public static serviceCatalog = 'serviceCatalog';
    public static TICKETING = 'ticketing';
    public static MAINTECKETINGlIST = 'main-tickets';
    public static GENERAL_SETTINGS_EMPLOYEE = 'general-Settings-employee';
    public static SUBTICKETINGLIST = 'sub-tickets';
    public static NEWCLIENTMANAGEMENT = 'new-client-management';
    public static services = 'services';
    public static dataManagmentRoute = { id: 4, name: 'platformManagement', path: RouterPathConfig.DATA_MANAGEMENT };
    public static requestsRoute = { id: 5, name: 'requests-header', path: '/admin/new-requests' };
    public static requestsRouteAccountManager = { id: 5, name: 'requests-header', path: '/account-manager/new-requests' };
    public static requestsRouteRequester = { id: 5, name: 'requests-header', path: '/requester/new-requests' };
    public static fileManagmentRoute = { id: 10, name: 'fileManagement', path: RouterPathConfig.FILE_MANAGEMENT, secondary_id: 43 };
    public static periodicReviewRoute = { id: 11, name: 'periodicReview', path: RouterPathConfig.PERIODIC_REVIEW, secondary_id: 44 };
    public static periodicReviewReportRoute = {
        id: 11,
        name: 'periodicReview',
        path: RouterPathConfig.PERIODIC_REVIEW + '/' + RouterPathConfig.PERIODIC_REVIEW_PATH.REPORTS,
        secondary_id: 44
    };
    public static periodicReviewSharedReportRoute = {
        id: 11,
        name: 'periodicReview',
        path: RouterPathConfig.PERIODIC_REVIEW + '/' + RouterPathConfig.PERIODIC_REVIEW_PATH.SHARED_REPORTS,
        secondary_id: 44
    };

    public static dashboard = 'dashboard';
    public static CALLS_RECORD_DASHBOARD_PATH = {
        CLIENTS_LIST_PATH: 'clients-list',
        EMPLOYEES_LIST_PATH: 'employees-list',
        ALL_CALLS_LIST_PATH: 'all-calls-list',
        CANCElED_CALLS_LIST_PATH: 'canceled-calls-list',
        CLOSED_CALLS_LIST_PATH: 'closed-calls-list'
    };
    public static MESSAGECENTER = 'message-center';
    public static delegationRequestRoute = { id: 15, name: 'delegationRequest', path: RouterPathConfig.DELEGATION, secondary_id: 45 };
}
